function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03756 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03756 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.5 6C0.5 5.72386 0.723858 5.5 1 5.5H11C11.2761 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.2761 6.5 11 6.5H1C0.723858 6.5 0.5 6.27614 0.5 6Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.50012 6.00127C4.53438 7.53869 5.06313 9.01885 6 10.2259C6.93687 9.01885 7.46562 7.53869 7.49988 6.00127C7.46562 4.46385 6.93687 2.9837 6 1.77667C5.06313 2.9837 4.53438 4.46385 4.50012 6.00127ZM6 1.00127L5.63083 0.664062C4.29845 2.12273 3.54126 4.0157 3.50011 5.99086C3.49996 5.9978 3.49996 6.00475 3.50011 6.01169C3.54126 7.98685 4.29845 9.87982 5.63083 11.3385C5.72556 11.4422 5.85954 11.5013 6 11.5013C6.14046 11.5013 6.27444 11.4422 6.36917 11.3385C7.70155 9.87982 8.45874 7.98685 8.49989 6.01169C8.50004 6.00475 8.50004 5.9978 8.49989 5.99086C8.45874 4.0157 7.70155 2.12273 6.36917 0.664062L6 1.00127Z"
});

var SvgEarth = function SvgEarth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#29394D",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEarth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/earth.4506f7dd.svg";
export { ForwardRef as ReactComponent };